export const environment = {
    appName: 'Event Checkin',
    serviceHostName: 'https://api-uat-hilldistrictgrandstand.txlivestockshows.com'
};